<template>
  <Layout @table-search="fetchData">
    <div style="width: 100%; margin-top: 57px">
      <div class="loading-infinite" v-if="loading">
        <div>
          <q-spinner-facebook color="primary" size="40px"/>
          <div class="text-grey-7">Loading</div>
        </div>
      </div>
      <q-card style="padding: 15px" v-if="data.length === 0 && !loading">
        <empty-value description="If you want to add vehicle please go to vehicle page." name="vehicle"></empty-value>
      </q-card>
      <div v-else>
        <div class="q-my-md" v-if="!loading">
          <table-export :company_id="companyFilter.id" :location_id="multiFilter"
                        :statuses="statusFilter"></table-export>
        </div>
        <div class="result-of-future">
          <div v-if="data.length > 0 && !loading" id="table-scroll" class="table-scroll" ref="tablev2">
            <q-btn
              v-if="data.length > 0"
              class="glossy custom-item-icon-3 left-0"
              style="margin-left: -10px"
              @mousedown="shiftLeft()"
              @mouseup="shiftLeftEnd()"
              round
              color="primary"
              icon="fas fa-arrow-left"
            />
            <q-btn
              v-if="data.length > 0"
              class="glossy custom-item-icon-3 right-0"
              @mouseup="shiftRightEnd()"
              @mousedown="shiftRight()"
              round
              color="primary"
              icon="fas fa-arrow-right"
            />
            <table id="main-table" class="main-table">
              <tr>
                <th></th>
                <th></th>
                <th colspan="2">Market Avg</th>
                <th colspan="9">
                  Manheim Current Auction Prices Average Values
                </th>
              </tr>
              <tr>
                <th>By Make/Model/Year</th>
                <th>Qty</th>
                <th colspan="1">Avg Of Mileage</th>
                <th colspan="1">Avg of Avg Condition Grade</th>

                <th colspan="1">Above Condition</th>
                <th colspan="1">Avg Condition</th>
                <th colspan="1">Below Condition</th>
                <th colspan="1">1 Yr Older Vehicle Mile Assumption</th>
                <th colspan="1">1 Yr Older Vehicle Average Condition Price</th>
                <th colspan="1">Avg of % Change</th>
                <th colspan="1">Total of Above Condition</th>
                <th colspan="1">Total Of Average Cond</th>
                <th colspan="1">Total of Below Condition</th>
              </tr>
              <tr v-for="(item, index) in data" :key="item.id" class="hoverable-tr" @click="handleClick(item, index)">
                <td :style="styleBinder(item)">
                  {{ item.brand || item.model || item.model_detail || item.year }}
                  <i
                    v-if="item.brand || item.model || item.model_detail"
                    class="fas fa-caret-down"
                    style="margin-right: 5px"
                  ></i>
                </td>
                <td style="min-width: 100px">
                  {{ thousandSeperator(item.count) }}
                </td>
                <td style="min-width: 100px">
                  {{ thousandSeperator(item.average_mileage) }}
                </td>
                <td style="min-width: 100px">
                  {{ item.average_condition_grade }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.average_excellent) }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.average_good) }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.average_fair) }}
                </td>
                <td style="min-width: 100px">
                  {{ thousandSeperator(item.average_one_year_older_mileage) }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.average_one_year_older_condition_price) }}
                </td>
                <td style="min-width: 100px">{{ Math.round(item.average_of_change * 100) }}%</td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.total_excellent) }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.total_good) }}
                </td>
                <td style="min-width: 100px">
                  {{ numberToCurrency(item.total_fair) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import EmptyValue from '@/components/EmptyValue'
import TableExport from '@/components/TableExport.vue'
import axios from '../axios'
import {defaultStatusValues} from "@/enums";

export default {
  components: {
    EmptyValue,
    Layout,
    TableExport
  },
  data() {
    return {
      rightInterval: null,
      leftInterval: null,
      data: [],
      firstRequest: true
    }
  },
  computed: {
    params() {
      const body = {}
      body.company_id = this.companyFilter?.id
      this.multiFilter.length > 0 &&
      Array.isArray(this.multiFilter) &&
      (body.location_id = this.multiFilter.map(({id}) => id))
      this.tagSelection.length > 0 &&
      Array.isArray(this.tagSelection) &&
      (body.tag_id = this.tagSelection.map(({id}) => id))
      this.statusFilter.length > 0 &&
      Array.isArray(this.statusFilter) &&
      (body.statuses = this.statusFilter.map(({value}) => value))
      return body
    },
    tagSelection() {
      return this.$store.state.historicalTrend.tagSelection
    },
    loading: {
      get() {
        return this.$store.state.historicalTrend.loading
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_LOADING', val)
      }
    },
    tags: {
      get() {
        return this.$store.state.tag.tags
      },
      set(val) {
        this.$store.commit('tag/SET_TAGS', val)
      }
    },
    vehicles: {
      get() {
        return this.$store.state.historicalTrend.vehicles
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_VEHICLES', val)
      }
    },
    companyFilter: {
      get() {
        return this.$store.state.historicalTrend.companyFilter
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_COMPANY_FILTER', val)
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.historicalTrend.multiFilter
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_MULTI_FILTER', val)
      }
    },
    statusFilter: {
      get() {
        return this.$store.state.historicalTrend.statusFilter
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_STATUS_FILTER', val)
      }
    },
    locations: {
      get() {
        return this.$store.state.historicalTrend.locations
      },
      set(val) {
        this.$store.commit('historicalTrend/SET_LOCATIONS', val)
      }
    }
  },
  methods: {
    numberToCurrency(number = 0) {
      return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    },
    thousandSeperator(number = 0) {
      return number.toLocaleString('en-US').split('.')[0]
    },
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    styleBinder(item) {
      let align = ''
      let weight = ''
      if (item.brand) {
        align = 'left'
        weight = '900'
      } else if (item.model) {
        weight = '500'
        align = 'center'
      } else if (item.model_detail) {
        weight = '300'
        align = 'right'
      } else if (item.year) {
        weight = '100'
        align = 'right'
      }

      return `padding:0px 10px !important;text-align:${align} !important;min-width: 200px; font-weight: ${weight}`
    },
    handleClick(item, index) {
      if ('models' in item) {
        if (this.data.some(({id}) => item.models.map(i => i.id).includes(id))) {
          const ids = item.models.map(s => s.id).concat(...item.models.map(s => s.years.map(s => s.id)))
          this.data = this.data.filter(s => !ids.includes(s.id))
        } else {
          this.data.splice(index + 1, 0, ...item.models)
        }
      } else if ('model_details' in item) {
        if (this.data.some(({id}) => item.model_details.map(s => s.id).includes(id))) {
          this.data = this.data.filter(s => !item.model_details.map(s => s.id).includes(s.id))
        } else {
          this.data.splice(index + 1, 0, ...item.model_details)
        }
      } else if ('years' in item) {
        if (this.data.some(({id}) => item.years.map(s => s.id).includes(id))) {
          this.data = this.data.filter(s => !item.years.map(s => s.id).includes(s.id))
        } else {
          this.data.splice(index + 1, 0, ...item.years)
        }
      }
    },
    async fetchData() {
      try {
        this.loading = true
        const params = {...this.params}
        if (this.firstRequest) {
          this.firstRequest = false
          params.statuses = defaultStatusValues
        }
        const {data: {data}} = await axios.post('/vehicle-analysis/tree-view-by-make-and-model', null, {
          params
        })
        this.data = data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getTags() {
      try {
        const {data} = await axios.get('vehicle-tags')
        this.tags = data.data
      } catch (error) {
      }
    },
    async getLocations(companyId) {
      if (companyId) {
        try {
          this.loading = true
          const params = {company_id: companyId}
          const {data} = await axios.get(`locations`, {params})
          this.locations = data.data
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    }
  },
  async mounted() {
    await this.fetchData()
    this.$store.state.tag.tags.length === 0 ? await this.getTags() : ''
  },
  watch: {
    // params: {
    //   handler(_, _2) {
    //     this.fetchData();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    companyFilter(n, _) {
      this.multiFilter = []
      n && n.id ? this.getLocations(n.id) : ''
    }
  }
}
</script>

<style>
.q-tree__node-header-content:first-child {
  font-weight: bold;
}
</style>
